'use strict';

var showMore = require('../../../../../../../../../../_virtual/showMore.cjs');

(function (exports) {

	/**
	 * Controls the flow of controls within a ShowMore Accordion
	 */ exports.SHOW_MORE_DIRECTIONS = void 0;
	(function(SHOW_MORE_DIRECTIONS) {
	    SHOW_MORE_DIRECTIONS["left"] = "left";
	    SHOW_MORE_DIRECTIONS["center"] = "center";
	})(exports.SHOW_MORE_DIRECTIONS || (exports.SHOW_MORE_DIRECTIONS = {}));
	
} (showMore.__exports));
//# sourceMappingURL=showMore.cjs.map
